var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SpreadsheetProcessorCtrl = function () {
    function SpreadsheetProcessorCtrl($scope, $state, $injector, $http, ModalService, $document, $timeout, StateUtils, httpSettings, spreadsheetProcessorConfig) {
        _classCallCheck(this, SpreadsheetProcessorCtrl);

        this.$document = $document;
        this.$timeout = $timeout;
        this.ModalService = ModalService;
        this.$injector = $injector;
        this.$state = $state;
        this.$http = $http;
        this.submissionVM = StateUtils.activeDataForState(true).model;
        this.jobID = this.submissionVM.quoteID ? this.submissionVM.quoteID.value : this.submissionVM.jobID.value;

        var xCenterDownloadURI = '' + httpSettings.serviceBaseURLs.pc;
        this.templateDownloadEndpointURL = xCenterDownloadURI + spreadsheetProcessorConfig.downloadTemplateURL.concat('/').concat(this.jobID);
        this.templateUploadEndpointURL = spreadsheetProcessorConfig.uploadTemplateURL;
        this.existingLocations = this.submissionVM.lobData.commercialProperty.coverables.locations;

        this.showManualEntryLink = this.showManualEntryLink ? this.showManualEntryLink : false;

        this.showDownloadLoader = true;
        this.documentMetaDataTemplate = {
            docUID: '001',
            documentType: 'other',
            securityType: 'unrestricted',
            status: 'approved',
            jobNumber: this.jobID
        };

        this.getFileUploadStatus = function (data) {

            var isUndefinedOrZero = function isUndefinedOrZero(value) {
                return value === undefined || value === 0;
            };

            var isFailedUnchanged = function isFailedUnchanged(value) {
                return value.rowsRead > 0 && isUndefinedOrZero(value.rowsWithErrors) && isUndefinedOrZero(value.rowsNew) && isUndefinedOrZero(value.rowsEdited) && isUndefinedOrZero(value.rowsRemoved);
            };

            if (data.fatalErrors) {
                return 'fail-processing';
            } else if (isUndefinedOrZero(data.rowsRead)) {
                return 'fail-empty';
            } else if (isFailedUnchanged(data)) {
                return 'fail-unchanged';
            } else if (data.rowsWithErrors === data.rowsRead) {
                return 'fail-full';
            } else if (data.rowsWithErrors > 0) {
                return 'partial';
            }
            return 'success';
        };

        this.registerFileUploadEventListeners($scope);
    }

    _createClass(SpreadsheetProcessorCtrl, [{
        key: 'registerFileUploadEventListeners',
        value: function registerFileUploadEventListeners($scope) {
            var _this = this;

            $scope.$on('fileuploadadd', function () {
                _this.showDownloadLoader = false;
            });

            $scope.$on('fileuploaddone', function (e, data) {
                _this.showDownloadLoader = true;
                _this.processData(data.response().result.result);

                var status = _this.getFileUploadStatus(data.response().result.result);
                var goToInitialScreen = function goToInitialScreen() {
                    _this.$state.go('cpBuildingWizardInitialScreen', { spreadsheetProcessorResult: {
                            'status': status,
                            'data': data.response().result.result
                        } });
                };
                var apply = true;
                var timeout = null;

                _this.$timeout(goToInitialScreen, timeout, apply);
            });

            $scope.$on('fileuploadfail', function () {
                _this.showDownloadLoader = true;
                _this.$state.go('cpBuildingWizardInitialScreen', { spreadsheetProcessorResult: {
                        'status': 'fail-processing',
                        'data': null
                    } });
            });
        }
    }, {
        key: 'processData',
        value: function processData(data) {

            if (data.lOBData.newlyAddedBuildings) {
                if (this.submissionVM.newlyAddedBuildingList) {
                    this.submissionVM.newlyAddedBuildingList = this.submissionVM.newlyAddedBuildingList.concat(data.lOBData.newlyAddedBuildings);
                } else {
                    this.submissionVM.newlyAddedBuildingList = data.lOBData.newlyAddedBuildings;
                }
            }

            this.existingLocations.value = data.lOBData.locations;
        }
    }, {
        key: 'downloadAgain',
        value: function downloadAgain() {
            this.templateDownloaded = false;
        }
    }, {
        key: 'downloadTemplate',
        value: function downloadTemplate() {
            var _this2 = this;

            this.downloadTemplatePromise = this.$http.get(this.templateDownloadEndpointURL, { responseType: 'arraybuffer' });
            this.downloadTemplatePromise.then(function (response) {
                try {
                    var filename = response.headers('Content-Disposition').replace('attachment; filename=', '');
                    var blob = new Blob([response.data], {
                        type: response.headers('Content-Type')
                    });

                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        var downloadContainer = angular.element('<div data-tap-disabled="true"><a></a></div>');
                        var downloadLink = angular.element(downloadContainer.children()[0]);
                        downloadLink.attr('href', window.URL.createObjectURL(blob));
                        downloadLink.attr('download', filename);
                        downloadLink.attr('target', '_blank');
                        _this2.$document.find('body').append(downloadContainer);
                        _this2.$timeout(function () {
                            downloadLink[0].click();
                            downloadLink.remove();
                        }, null);
                    }
                    _this2.templateDownloaded = true;
                } catch (e) {
                    _this2.ModalService.showError('gw-portals-policytransaction-common-angular.components.spreadsheetProcessor.Error', 'gw-portals-policytransaction-common-angular.components.spreadsheetProcessor.Something went wrong. Template was not downloaded. Please try again.');
                    _this2.templateDownloaded = false;
                }
            }, function () {
                _this2.ModalService.showError('gw-portals-policytransaction-common-angular.components.spreadsheetProcessor.Error', 'gw-portals-policytransaction-common-angular.components.spreadsheetProcessor.Something went wrong. Template was not downloaded. Please try again.');
                _this2.templateDownloaded = false;
            });
        }
    }, {
        key: 'enterInfoManually',
        value: function enterInfoManually() {
            this.$state.params.manualAddBuildingDelegator();
        }
    }]);

    return SpreadsheetProcessorCtrl;
}();

SpreadsheetProcessorCtrl.$inject = ['$scope', '$state', '$injector', '$http', 'ModalService', '$document', '$timeout', 'StateUtils', 'httpSettings', 'qnb.spreadsheetProcessorConfig'];

export default SpreadsheetProcessorCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-policytransaction-common-angular/components/spreadsheetProcessor/spreadsheetProcessorCtrl.js
// module id = 1016
// module chunks = 0